<template>
  <div v-if="recommendations.length > 0" class="recommended-products">
    <div v-if="heading" class="mb-24">
      <h3 v-if="headingSize === 'large'" class="text-heading">
        {{ heading }}
      </h3>
      <h4 v-else-if="headingSize === 'medium'" class="text-heading-small">
        {{ heading }}
      </h4>
      <div v-else class="text-small-medium">
        {{ heading }}
      </div>
    </div>
    
    <div class="flex flex-wrap w-full">
      <ProductSpot
        v-for="(product, i) in recommendations"
        :key="`${product.objectID || i}-recommended-spot`"
        :product="new Product({ 
          ecomData: product, 
          contentData: null,
          algoliaObjectID: product.objectID 
        })"
        :index="i"
        :is-mostright="(!isMobile && (i + 1) % productsPerRow === 0) || (isMobile && (i + 1) % 2 === 0)"
        :is-mobile="isMobile"
      />
    </div>
  </div>
  <div v-else-if="isLoading" class="text-center py-24">
    <div class="text-small text-muted">
      {{ $lang('recommendations', 'loading') || 'Loading recommendations...' }}
    </div>
  </div>
</template>

<script setup lang="ts">
import ProductSpot from '~/components/productlist/ProductSpot.vue';
import Product from '~/models/product';
import { useUiStore } from '~/store/ui';

interface Props {
  recommendations: Array<Record<string, string | number | boolean | object>>;
  heading?: string;
  headingSize?: 'small' | 'medium' | 'large';
  productsPerRow?: number;
  isLoading?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  heading: '',
  headingSize: 'medium',
  productsPerRow: 4,
  isLoading: false,
});

const uiStore = useUiStore();
const isMobile = computed(() => uiStore.isMobile);
</script>

<style scoped lang="postcss">
.recommended-products {
  @apply w-full;
}
</style>
